import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TextField } from '@totalsoft/rocket-ui';
import { Grid, Typography, Tooltip } from '@mui/material';

const VerificationTestFormulaListComponent = ({ verificationTestResponse }) => {
  const { t } = useTranslation();
  return (
    <Grid container xs={11} md={12} spacing={2}>
      <Grid item xs={2}>
        <Typography>{t('VerificationTypes.TestingApplicabilityFormula.PartnerRoleName')}</Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>{t('VerificationTypes.TestingApplicabilityFormula.PartnerName')}</Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>{t('VerificationTypes.TestingApplicabilityFormula.EvaluationString')}</Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography>{t('VerificationTypes.TestingApplicabilityFormula.Result')}</Typography>
      </Grid>
      {verificationTestResponse &&
        verificationTestResponse.map((item, idx) => (
          <Grid container item xs={12} key={idx} spacing={2}>
            <Grid item xs={2}>
              <TextField fullWidth value={item.partnerRoleName} name={'partnerRoleName'} disabled />
            </Grid>
            <Grid item xs={4}>
              <TextField fullWidth value={item.partnerName} name={'partnerName'} disabled />
            </Grid>
            <Grid item xs={4}>
              <Tooltip title={item.evaluationString}>
                <TextField fullWidth value={item.evaluationString} name={'evaluationString'} disabled />
              </Tooltip>
            </Grid>
            <Grid item xs={2}>
              <TextField fullWidth value={item.result} name={'result'} disabled />
            </Grid>
          </Grid>
        ))}
    </Grid>
  );
};

VerificationTestFormulaListComponent.propTypes = {
  verificationTestResponse: PropTypes.array.isRequired
};

export default VerificationTestFormulaListComponent;
